import template from './WidgetHelpCenterBuilderView.html';
import { WidgetHelpBuilderController } from './WidgetHelpCenterBuilderController';
export const WidgetHelpBuilderComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: WidgetHelpBuilderController,
    controllerAs: '$ctrl',
    template,
};
